import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/storage';
import 'firebase/functions'

import { firebaseConfig } from 'src/config';

let firebaseTempProject;
if (!firebase.apps.length) {
  firebaseTempProject = firebase.initializeApp(firebaseConfig);
}

export const auth = firebase.auth
export const firebaseProject = firebaseTempProject;
export const firestore = firebaseProject.firestore();
export const storage = firebaseProject.storage(
  `gs://${process.env.REACT_APP_FIREBASE_STORAGE_BUCKET}`
);
export const functions = firebaseProject.functions()
export { firebase }
